import {createGlobalContext} from '@acng/frontend-relativity';
import {CTX_PROVIDE} from '@acng/frontend-relativity/minify';

export const ctxVipPoints = createGlobalContext(NaN);

/**
 * @param {import('acng/userPool/factory/user').User} user
 * @param {core.Sock} sock
 * @param {angular.IRootScopeService} $rootScope
 */
const runSock = (user, sock, $rootScope) => {
  $rootScope.$on('userPool.login.success', () => ctxVipPoints[CTX_PROVIDE](null, user.points));
  sock.registerHandler('points', (points) => ctxVipPoints[CTX_PROVIDE](null, points));
};

/** @type {angular.Injectable<runSock>} */
export const updateVipPoints = ['user', 'sock', '$rootScope', runSock];
